// Glossary for consistent Punjabi terminology across scheme pages and UI
export const glossaryPa: Record<string, string> = {
  // Section headings
  "Overview": "ਜਾਇਜ਼ਾ",
  "Objectives": "ਉਦੇਸ਼",
  "Eligibility": "ਯੋਗਤਾ",
  "Application Procedure": "ਅਰਜ਼ੀ ਦੀ ਪ੍ਰਕਿਰਿਆ",
  "Publish Date": "ਪ੍ਰਕਾਸ਼ਿਤ ਮਿਤੀ",
  "Funding Pattern": "ਵਿੱਤੀ ਬਣਤਰ",
  "Scheme History": "ਯੋਜਨਾ ਦਾ ਇਤਿਹਾਸ",
  "Aim": "ਮਕਸਦ",
  "Types of Development Works Covered": "ਵਿਕਾਸ ਕਾਰਜਾਂ ਦੀਆਂ ਕਿਸਮਾਂ",
  "Budget": "ਬਜਟ",
  "Source": "ਸਰੋਤ",
  "Duties and Functions": "ਜ਼ਿੰਮੇਵਾਰੀਆਂ ਅਤੇ ਕਾਰਜ",
  // Common UI labels
  "Scheme Details": "ਯੋਜਨਾ ਦਾ ਵੇਰਵਾ",
  "Create": "ਬਣਾਓ",
  "Manage": "ਪ੍ਰਬੰਧ ਕਰੋ",
  "Rural Development Department | Haryana": "ਪਿੰਡ ਵਿਕਾਸ ਵਿਭਾਗ | ਹਰਿਆਣਾ",
  // Common terms
  "Village": "ਪਿੰਡ",
  "Block": "ਖੰਡ",
  "District": "ਜ਼ਿਲ੍ਹਾ",
  // Misc
  "Development": "ਵਿਕਾਸ",
  "Infrastructure": "ਬੁਨਿਆਦੀ ਢਾਂਚਾ",
  "Employment": "ਰੋਜ਼ਗਾਰ",
  // Additional common scheme sections
  "Guidelines": "ਹਦਾਇਤਾਂ",
  "Contact": "ਸੰਪਰਕ",
  "Implementation Agency": "ਕਾਰਜਾਨਵੈਨ ਸੰਸਥਾ",
  "Benefits": "ਲਾਭ",
  "How to Apply": "ਅਰਜ਼ੀ ਕਿਵੇਂ ਦੇਣੀ ਹੈ",
  "Documents Required": "ਜ਼ਰੂਰੀ ਦਸਤਾਵੇਜ਼",
  "FAQs": "ਅਕਸਰ ਪੁੱਛੇ ਸਵਾਲ",
  "Helpline": "ਹੈਲਪਲਾਈਨ",
  "Coverage": "ਕਵਰੇਜ",
  "Features": "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ",
  "Monitoring": "ਨਿਗਰਾਨੀ",
  "Components": "ਘਟਕ",
  "Timeline": "ਸਮਾਂ-ਸਾਰਣੀ",
  "Eligibility Criteria": "ਯੋਗਤਾ ਮਾਪਦੰਡ",
  "Procedure": "ਪ੍ਰਕਿਰਿਆ",
  "Important Links": "ਮਹੱਤਵਪੂਰਨ ਲਿੰਕ",
  "Official Website": "ਆਧਿਕਾਰਿਕ ਵੈਬਸਾਈਟ",
  "Notes": "ਨੋਟਸ",
  // Administrative and technical roles/terms
  "Gram Panchayat": "ਗ੍ਰਾਮ ਪੰਚਾਇਤ",
  "Gram Sabha": "ਗ੍ਰਾਮ ਸਭਾ",
  "Panchayat Samiti": "ਪੰਚਾਇਤ ਸਮਿਤੀ",
  "Block Programme Officer": "ਬਲਾਕ ਪ੍ਰੋਗਰਾਮ ਅਧਿਕਾਰੀ",
  "District Programme Coordinator": "ਜ਼ਿਲ੍ਹਾ ਪ੍ਰੋਗਰਾਮ ਕੋਆਰਡੀਨੇਟਰ",
  "Job Card": "ਜਾਬ ਕਾਰਡ",
  "Permissible Works": "ਅਨੁਮਤ ਕੰਮ",
  "Water harvesting": "ਪਾਣੀ ਸੰਚੇਈ",
  "Afforestation": "ਵਨੀਕਰਨ",
  "Irrigation canals": "ਸਿੰਚਾਈ ਨਹਿਰਾਂ",
  // Scheme-wide technical and administrative terms
  "Worksite Facilities": "ਕਾਰਜਸਥਲ ਸਹੂਲਤਾਂ",
  "Material component": "ਸਾਮਗਰੀ ਘਟਕ",
  "Wage seeker": "ਮਜ਼ਦੂਰੀ ਮੰਗਣ ਵਾਲਾ",
  "Wage seekers": "ਮਜ਼ਦੂਰੀ ਮੰਗਣ ਵਾਲੇ",
  "Unskilled manual work": "ਬਿਨਾ ਦੱਖਲ ਹੱਥੀਂ ਕੰਮ",
  "Social audit": "ਸਮਾਜਿਕ ਨਿਰੀਖਣ",
  "Muster Roll": "ਮਸਟਰ ਰੋਲ",
  "muster roll": "ਮਸਟਰ ਰੋਲ",
  "Measurement Book": "ਮਾਪ ਪੁਸਤਕ",
  "Schedule of Rates": "ਦਰਾਂ ਦੀ ਸੂਚੀ",
  "Financial year": "ਆਰਥਿਕ ਵਰ੍ਹਾ",
  "Gram Rozgar Sahayak": "ਗ੍ਰਾਮ ਰੋਜ਼ਗਾਰ ਸਹਾਇਕ",
  "Programme Officer": "ਪ੍ਰੋਗਰਾਮ ਅਧਿਕਾਰੀ",
  "District Panchayat": "ਜ਼ਿਲ੍ਹਾ ਪੰਚਾਇਤ",
  "Panchayat Secretary": "ਪੰਚਾਇਤ ਸਕੱਤਰੀ",
  "Work completion certificate": "ਕਾਰਜ ਪੂਰਨਤਾ ਪ੍ਰਮਾਣ-ਪੱਤਰ",
  "Wage rate": "ਮਜ਼ਦੂਰੀ ਦਰ",
  "Asset creation": "ਸੰਪਤੀਆਂ ਦਾ ਸਿਰਜਣ",
  "Knowledge Resource Centre": "ਗਿਆਨ ਸਰੋਤ ਕੇਂਦਰ",
}

export default glossaryPa